<template>
  <div class="hajj-mission bg-white py-10">
    <div class="container mx-auto px-4">
      <!-- Заголовок -->
      <h2 class="text-2xl font-bold text-gray-800 mb-6">
        {{ $t("hajj.hajjMission") }}
      </h2>

      <!-- Основной блок -->
      <div class="bg-gray-100 rounded-3xl p-4 flex flex-col lg:flex-row gap-4">
        <!-- Левая часть с изображением -->
        <div class="lg:w-1/2 bg-white rounded-2xl overflow-hidden relative">
          <div class="aspect-[4/3] lg:aspect-auto h-full max-h-[512px]">
            <transition name="fade" mode="out-in">
              <img
                :key="activeIndex"
                :src="activeItem.image"
                alt="Hajj Mission"
                class="w-full h-full object-cover"
              />
            </transition>
          </div>
        </div>

        <!-- Правая часть со списком функций -->
        <div class="lg:w-1/2 space-y-0">
          <!-- Функция 1 -->
          <div
            v-for="(item, index) in missionItems"
            :key="item.title"
            @click="onItemClick(index)"
            class="mission-item rounded-2xl p-4 flex items-center gap-4 relative cursor-pointer"
            :class="{
              'bg-white': index === activeIndex,
            }"
          >
            <svg-icon
              class="w-8 h-8 flex-shrink-0 text-gray-500"
              :class="{
                'text-primary': index === activeIndex,
              }"
              :name="item.icon"
            />
            <span class="text-gray-800 font-semibold">{{ item.title }}</span>
            <div
              v-if="index === activeIndex"
              class="absolute bottom-0 left-0 h-0.5 bg-primary progress-line"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "HajjMission",
  components: {},
  data() {
    return {
      missionItems: [
        {
          icon: "mission-document",
          title: this.$t("mission.organizeHajj"),
          image: require("@/assets/images/mission/01.jpg"),
        },
        {
          icon: "mission-document",
          title: this.$t("mission.getQuota"),
          image: require("@/assets/images/mission/02.jpg"),
        },
        {
          icon: "mission-touroperator",
          title: this.$t("mission.approveOperators"),
          image: require("@/assets/images/mission/03.jpg"),
        },
        {
          icon: "mission-register",
          title: this.$t("mission.monitorRegistration"),
          image: require("@/assets/images/mission/04.jpg"),
        },
        {
          icon: "mission-advise",
          title: this.$t("mission.religiousAdvice"),
          image: require("@/assets/images/mission/05.jpg"),
        },
        {
          icon: "mission-check",
          title: this.$t("mission.qualityControl"),
          image: require("@/assets/images/mission/06.jpg"),
        },
        {
          icon: "mission-security",
          title: this.$t("mission.security"),
          image: require("@/assets/images/mission/07.jpg"),
        },
        {
          icon: "mission-report",
          title: this.$t("mission.evaluation"),
          image: require("@/assets/images/mission/08.jpg"),
        },
      ],
      activeIndex: 0,
    };
  },
  computed: {
    activeItem() {
      return this.missionItems[this.activeIndex];
    },
  },
  mounted() {
    this.startAutoSlide();
  },
  beforeUnmount() {
    this.stopAutoSlide();
  },
  methods: {
    onItemClick(index) {
      this.activeIndex = index;
      this.stopAutoSlide();
      this.startAutoSlide();
    },
    startAutoSlide() {
      this.autoSlideTimer = setInterval(() => {
        this.activeIndex = (this.activeIndex + 1) % this.missionItems.length;
      }, 3000);
    },
    stopAutoSlide() {
      clearInterval(this.autoSlideTimer);
    },
  },
});
</script>

<style scoped>
.text-primary {
  color: #3db076;
}

.bg-primary {
  background-color: #3db076;
}

/* Плавное переключение изображения */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* Плавное переключение элементов списка */
.mission-item {
  transition: background-color 0.2s ease;
}

.mission-item svg {
  transition: color 0.2s ease;
}

.progress-line {
  animation: progress 3s linear forwards;
}

@keyframes progress {
  from {
    width: 0;
  }
  to {
    width: 100%;
  }
}
</style>
